import * as React from "react";
const SvgSave = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.5 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4.5zM8 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4m2-7H4V3h6z" }));
export {
  SvgSave as default
};
//# sourceMappingURL=save.js.map
